<mat-toolbar class="mat-toolbar-fix" *ngFor="let usuario of datos" fxLayout="row" fxLayoutAlign="space-between stretch">
  <div class="box logo">
    <img src="assets/images/logo.png" alt="logo">
  </div>
  
  <div class="box user-info" fxLayout="column" fxLayoutAlign="space-between start">
    <div fxLayout="row">
      <img src="assets/images/person.PNG" alt="user">
      <div fxLayout="column" fxLayoutAlign="start" class="lbl-user">
        <label style="font-size:0.65vw; display:block; max-width:100%; white-space:normal; word-wrap:break-word;" for="welcome">Bienvenido: 
          {{ usuario.NOMBRE }}</label>
        <label for="office">{{ usuario.OFICINA }}</label>
      </div>
    </div>
    <label for="date" class="lbl-date">Fecha: {{ today }}</label>
  </div>

  <div class="box policy esconder">
    <div fxLayout="column">
      <!-- <a (click)="reporter(usuario.CODSUC)">Renovadas</a> -->
      <!-- <a (click)="reportec(usuario.CODSUC)">Cobradas</a> -->
    </div>
    <img class="image" src="assets/images/document.PNG" alt="document">
  </div>

  <div class="box messages esconder">
    <button class="not-button" matBadge="1" matBadgeColor="warn" [matBadgeHidden]="notification" (click)="InverView()">
      <img src="assets/images/sms.PNG" alt="messages">
    </button>
    <div *ngIf="viewMsjs" fxLayout="column" fxLayoutGap="10px" class="principal-messages">
      <h3 class="bold">{{ !MsjsList || MsjsList.length === 0 ? 'No tienes mensajes' : 'Tus mensajes' }}</h3>
      <div fxLayout="column" fxLayoutGap="10px" class="content-messages">
        <div *ngFor="let data of MsjsList" fxLayout="column">
          <div fxLayout="row" fxLayoutAlign="space-between start" class="message">
            <img src="assets/images/avatar.png" alt="">
            <div>
              <h3 class="bold text-eclipse">{{ this.firstFourWords(data.MENSAJE) }}</h3>
              <span class="text-eclipse">{{ this.NextFourWords(data.MENSAJE) }}</span>
            </div>
            <button (click)="InverView()" mat-button [routerLink]="['/message', data.MENSAJE]">Ver más</button>
          </div>
          <mat-divider></mat-divider>
        </div>
      </div>
    </div>
  </div>

  <div class="box mail esconder">
    <img src="assets/images/mail.PNG" alt="mail">
  </div>

  <div class="box birthday esconder">
    <!--<div fxLayout="column" fxLayoutAlign="start">
      <label class="lbl-birthday">{{ usuario.FECNAC === today ? 'Feliz Cumpleaños: ' : 'En Seguros Caroni estamos de aniversario y premiamos tu lealtad con la promoción 27 por los 27 en las pólizas de salud.' }}</label>
      <label class="lbl-birthday">{{ usuario.FECNAC === today ? usuario.NOMBRE : '' }}</label>
    </div>
    <img *ngIf="usuario.FECNAC === today" src="assets/images/gift.PNG" alt="gift">-->
  </div>
</mat-toolbar>
<mat-sidenav-container class="sidenav-container">
  <mat-sidenav
    #drawer
    class="sidenav"
    [fixedTopGap]="55"
    fixedInViewport="true"
    [attr.role]="(isHandset$ | async) ? 'dialog' : 'navigation'"
    [mode]="(isHandset$ | async) ? 'over' : 'side'"
    [opened]="!(isHandset$ | async) && viewSidenav"
  >
    <!-- <mat-toolbar>Menu</mat-toolbar> -->
    <mat-nav-list>
      <!--<mat-list-option
        *ngFor="let option of permisos"
        routerLinkActive="active-link"
        (click)="toggleOpenOption(option)"
         class="letras" mat-list-item
        >{{ option.DESAPLIC }}</a
      >-->
      <mat-nav-list>
        <!--<a
          *ngFor="let option of permisos"
          routerLinkActive="active-link"
          (click)="toggleOpenOption(option)"
           class="letras" mat-list-item
          >{{ option.DESAPLIC }}</a
        >-->
        <!-- [routerLink]="[option.CODAPLIC]" -->
        <!-- <div mat-subheader>INICIO</div> -->
         <a mat-subheader [routerLink]="'/'" class="solo letras principal-options">INICIO</a>
        <mat-accordion>
          <mat-expansion-panel>
            <mat-expansion-panel-header>
              <mat-panel-title class="principal-options">
                LIQUIDACIÓN
              </mat-panel-title>
            </mat-expansion-panel-header>
            <a
              class="letras mueve"
              mat-list-item
              [routerLink]="''"
              ><mat-icon class="material-icons">how_to_reg</mat-icon> Liquidación Clínica</a>
            <a class="letras mueve"
              mat-list-item
              [routerLink]="''"> <mat-icon class="material-icons">how_to_reg</mat-icon> Relación de Obligaciones </a>
          </mat-expansion-panel>
          <!-- <mat-expansion-panel> -->
            <!-- <mat-expansion-panel-header>
              <mat-panel-title class="principal-options">
                Cotizar/Emitir
              </mat-panel-title>
            </mat-expansion-panel-header> -->
            <!-- <a class="letras" mat-list-item [routerLink]="'/funeral-quote'"
              ><mat-icon class="material-icons">how_to_reg</mat-icon>Pólizas de
              Funerario</a
            >
            <a class="letras" mat-list-item [routerLink]="'/hcm-quote'"
              ><mat-icon class="material-icons">how_to_reg</mat-icon>Pólizas de
              HCM</a
            >
            <a class="letras" mat-list-item [routerLink]="'/car-quote'"
              ><mat-icon class="material-icons">how_to_reg</mat-icon>Pólizas de
              Automovil</a> -->
            <!--<a
              class="letras"
              mat-list-item
              [routerLink]="'/quotes-consultation'"
              ><mat-icon class="material-icons">how_to_reg</mat-icon>Consulta de
              Cotizaciones</a-->
            
          <!-- </mat-expansion-panel> -->
          <!-- <mat-expansion-panel> -->
            <!-- <mat-expansion-panel-header> -->
              <!-- <mat-panel-title class="principal-options"> -->
                <!-- Pagos -->
              <!-- </mat-panel-title> -->
            <!-- </mat-expansion-panel-header> -->
            <!-- <a  class="letras" mat-list-item [routerLink]="'/payment'"><mat-icon class="material-icons">how_to_reg</mat-icon>Pago en línea</a> -->
            <!-- <a  class="letras" mat-list-item [routerLink]="'/pending-paid'"><mat-icon class="material-icons">how_to_reg</mat-icon>Impresión Relación de Ingreso</a> -->
            <!-- <a  class="letras" mat-list-item (click)="getCuenta()"><mat-icon class="material-icons">how_to_reg</mat-icon>Cuentas bancarias</a> -->
            <!-- <a  class="letras" mat-list-item [routerLink]="'/deposits-and-transfer'"><mat-icon class="material-icons">how_to_reg</mat-icon>Depósitos y transferencias</a> -->
          <!-- </mat-expansion-panel> -->
          <!--<mat-expansion-panel>
            <mat-expansion-panel-header>
              <mat-panel-title class="principal-options">
                Siniestros
              </mat-panel-title>
            </mat-expansion-panel-header>
            <a  class="letras" mat-list-item [routerLink]="'/claims-consultation'"><mat-icon class="material-icons">how_to_reg</mat-icon>Consulta de siniestros</a>
          </mat-expansion-panel>-->
          <mat-expansion-panel>
            <mat-expansion-panel-header>
              <mat-panel-title class="principal-options">
                Consultas
              </mat-panel-title>
            </mat-expansion-panel-header>

            <a              class="letras"
              mat-list-item
              [routerLink]="''">
              <mat-icon class="material-icons">how_to_reg</mat-icon>Facturas Pagadas</a>

              <a              class="letras"
              mat-list-item
              [routerLink]="''">
              <mat-icon class="material-icons">how_to_reg</mat-icon>Facturas Pendientes</a>
            <!-- <a              class="letras"
              mat-list-item
              [routerLink]="'/healthcare-providers'">
              <mat-icon class="material-icons">how_to_reg</mat-icon>Proveedores de Salud</a>
            <a class="letras" mat-list-item [routerLink]="'/aps-providers'"
              ><mat-icon class="material-icons">how_to_reg</mat-icon>Proveedores de Aps</a >
            <a class="letras" mat-list-item (click)="getProveedor()" >
              <mat-icon class="material-icons">how_to_reg</mat-icon>Proveedores
              odontológicos</a >
            <a class="letras" mat-list-item (click)="getOftalmologo()" >
                <mat-icon class="material-icons">how_to_reg</mat-icon>Proveedores
                Oftalmológicos</a > 
            <a class="letras" mat-list-item (click)="getDermatologo()" >
            <mat-icon class="material-icons">how_to_reg</mat-icon>Proveedores Dermatológicos</a >  
            <a class="letras" mat-list-item (click)="getAuxiliar()" >
            <mat-icon class="material-icons">how_to_reg</mat-icon>Auxiliar psicológico</a >  
            <a class="letras" mat-list-item (click)="getFunerario()" >
            <mat-icon class="material-icons">how_to_reg</mat-icon>Servicio funerarios</a >     -->
          </mat-expansion-panel>

          <mat-expansion-panel>
            <mat-expansion-panel-header>
              <mat-panel-title class="principal-options">
                REPORTES
              </mat-panel-title>
            </mat-expansion-panel-header>

            <a              class="letras"
              mat-list-item
              [routerLink]="''">
              <mat-icon class="material-icons">how_to_reg</mat-icon>Pagos pendientes</a>

              <a              class="letras"
              mat-list-item
              [routerLink]="''">
              <mat-icon class="material-icons">how_to_reg</mat-icon>Pagos Realizados</a>

              <a              class="letras"
              mat-list-item
              [routerLink]="''">
              <mat-icon class="material-icons">how_to_reg</mat-icon>Estado de Cuenta</a>

              <a              class="letras"
              mat-list-item
              [routerLink]="''">
              <mat-icon class="material-icons">how_to_reg</mat-icon>Reporte ARC</a>

          </mat-expansion-panel>

          <!-- <mat-expansion-panel>
            <mat-expansion-panel-header>
              <mat-panel-title class="principal-options">
                Gestión usuarios
              </mat-panel-title>
            </mat-expansion-panel-header>
            <a class="letras" mat-list-item [routerLink]="'/key-change'"
              ><mat-icon class="material-icons">how_to_reg</mat-icon>Cambiar
              clave</a
            >
          </mat-expansion-panel>
          <a
            mat-list-item
            class="solo letras principal-options"
            [routerLink]="'/download-area'"
            >Zona de descarga</a
          > -->
          <a
            mat-list-item
            class="solo letras principal-options"
            *ngIf="url != '/login' && true"
            (click)="logout()"
            >Salir</a
          >
        </mat-accordion>
      </mat-nav-list>
    </mat-nav-list>
  </mat-sidenav>
  <mat-sidenav-content>
    <mat-toolbar color="primary" class="toolbar-inside-content">
      <button
      *ngIf="viewSidenav"
      type="button"
      aria-label="Toggle sidenav"
      mat-icon-button
      (click)="drawer.toggle()">
      <mat-icon aria-label="Side nav toggle icon">menu</mat-icon>
      </button>

      <div fxLayout="row" fxLayoutAlign="center center">
        <button
          *ngIf="url != '/login' && !true"
          mat-button
          [routerLink]="['/login']"
        >
          
        </button>
        <button *ngIf="url != '/login' && true" (click)="logout()" mat-button>
          <mat-icon>close</mat-icon>
          Salir
        </button>

      </div>
    </mat-toolbar>
    <ng-content select="[content]"></ng-content>
    <app-footer></app-footer>
  </mat-sidenav-content>
</mat-sidenav-container>
